import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { AuditAction, AuditLogEntry } from '../types/auditLog';

export interface ListAuditLogsParams {
  page: number;
  pageSize: number;
  userId?: number;
  resource?: string;
  method?: string;
  action?: AuditAction;
  dateFrom?: string;
  dateTo?: string;
}

export const listAuditLogs = async (
  params: ListAuditLogsParams,
): Promise<PaginatedResponse<AuditLogEntry>> => {
  const { data } = await apiClient.get('/audit-logs', { params });
  return data;
};
